import { scope } from "../../../exports/debug";
import type { Expand } from "../../nexus/utils/utils.types";

export type ObjectToEntry<T> = Expand<{ [P in keyof T]: [P, T[P]] }[keyof T]>;

/**
 *
 */
export type ObjectToEntries<T> = ObjectToEntry<T>[];

/**
 *
 */
export const asyncScope = scope("gr.navigation");

/**
 *
 *
 */
export const NAV_META = "__nav_meta__";

/**
 *
 *
 */
export const NAV_SCOPES = "__nav_scopes__";

/**
 *
 *
 *
 *
 *
 */
export const defaultEntryComparator = <T extends [string, unknown]>(a: T, b: T): boolean => {
  /*                                                                                            */
  if (a[0] !== b[0]) return false;

  /*                                              */
  if (a[1] === b[1]) return true;

  /*                                                                                                     */
  try {
    return a[1] === decodeURIComponent(b[1] as never) || decodeURIComponent(a[1] as never) === b[1];
  } catch {
    /*                                                         */
    return false;
  }
};
